import flatpickr from 'flatpickr'
import { Turkish } from 'flatpickr/dist/l10n/tr.js'

document.addEventListener('DOMContentLoaded', function () {
  const harborItems = document.querySelectorAll('.select-liman-item')
  const aracItems = document.querySelectorAll('.select-arac-item')
  const limanInput = document.querySelector('.home-searchbar__liman')
  const kisiInput = document.querySelector('.home-searchbar__kisi')
  const aracInput = document.querySelector('.home-searchbar__arac')
  const selectArac = document.querySelector('.home-searchbar__select-arac')
  const selectKisi = document.querySelector(
    '.home-searchbar__select-people-count'
  )
  const selectLiman = document.querySelector('.home-searchbar__select-liman')
  const selectDate = document.querySelector('.home-searchbar__select-date')
  const tarihInput = document.getElementById('tarihInput')

  if (harborItems) {
    harborItems.forEach(function (item) {
      item.addEventListener('click', function () {
        const harborName = item.querySelector('.harbor-name').textContent.trim()
        limanInput.value = harborName
      })
    })
  }

  if (aracItems) {
    aracItems.forEach(function (item) {
      item.addEventListener('click', function () {
        const aracName = item.querySelector('.arac-name').textContent.trim()
        aracInput.value = aracName
      })
    })
  }

  if (tarihInput) {
    const fp = flatpickr(document.createElement('input'), {
      inline: true,
      locale: Turkish,
      enableTime: true,
      dateFormat: 'd.m.Y H:i',
      time_24hr: true,
      minuteIncrement: 60,
      minDate: 'today',
      appendTo: document.getElementById('takvimContainer'),
      onChange: function (selectedDates, dateStr, instance) {
        tarihInput.value = dateStr
      },
    })
  }

  const dropdowns = [
    { input: limanInput, menu: selectLiman },
    { input: tarihInput, menu: selectDate },
    { input: kisiInput, menu: selectKisi },
    { input: aracInput, menu: selectArac },
  ]

  dropdowns.forEach(({ input, menu }, _, array) => {
    if (input) {
      input.addEventListener('click', function () {
        array.forEach(({ menu: otherMenu }) => {
          if (otherMenu !== menu && !otherMenu.classList.contains('hidden')) {
            otherMenu.classList.add('hidden')
          }
        })
        menu.classList.toggle('hidden')
      })
    }
  })
})
